<template>
  <div class="contact-us">
    <h1>联系我们</h1>
    <div class="contact-content">
      <div class="contact-info">
        <h2>其他联系方式</h2>
        <!-- 添加点击事件 -->
        <p @click="copyEmail">请通过 <span class="email">{{ email }}</span> 邮件联系我们，并且附上所需的信息。我们将尽量在3天内回复您的邮件。</p>
        <h3>邮件指南</h3>
        <ol>
          <li>
            如果你发现本站存在 Bug，请联系我们并附上以下信息
            <ul>
              <li>描述具体发生了什么</li>
              <li>出现 Bug 的具体页面网址</li>
              <li>网页上的错误信息</li>
              <li>网页截图</li>
              <li>你的操作系统，浏览器版本，设备等等</li>
            </ul>
          </li>
          <li>
            激活账号
            <p>如果注册后没有收到验证码邮件，请先到垃圾邮件里找一找。你还可以再次尝试发送，本站会自动再次发送验证码邮件。</p>
          </li>

          <li>
            网站上的错误信息
            <p>如果你发现本站存在错误信息，如学校、导师姓名、院系等等，欢迎联系我们。请在邮件里附上具体的网址、错误信息和对应的正确信息。</p>
          </li>
          <li>
            问题、想法、建议
            <p>如果你有任何问题，联系我们之前请先查看<router-link to="/faq">常见问题页面</router-link> 。欢迎联系我们分享你的任何想法和建议。谢谢！</p>
          </li>
        </ol>
      </div>
    </div>
  </div>
</template>

<script>
import {ElMessage} from "element-plus";

export default {
  name: 'ContactUs',
  data() {
    return {
      form: {
        name: '',
        email: '',
        message: ''
      },
      // 定义邮箱地址
      email: 'support@halfpanda.cn'
    }
  },
  methods: {
    submitForm() {
      // 这里可以添加实际的表单提交逻辑，比如调用 API
      console.log('表单提交数据:', this.form)
      // 清空表单
      this.form = {
        name: '',
        email: '',
        message: ''
      }
      alert('留言已发送，我们会尽快与您联系！')
    },
    // 复制邮箱地址的方法
    copyEmail() {
      navigator.clipboard.writeText(this.email).then(() => {
        ElMessage.success('邮箱已复制！')
      }).catch((err) => {
        console.error('复制失败: ', err);
      });
    }
  }
}
</script>

<style scoped>
.contact-us {
  text-align: center;
  padding: 20px;
}

.contact-content {

/* 可以添加额外的样式来美化邮件指南部分 */
.contact-info ol, .contact-info ul {
  padding-left: 20px;
}

  /* 为邮箱地址添加样式 */
  .email {
    color: #007BFF; /* 蓝色文字 */
    text-decoration: underline; /* 下划线 */
    cursor: pointer; /* 鼠标悬停显示手型 */
  }

.contact-info li {
  margin-bottom: 20px; /* 增加列表项之间的间距 */
  list-style-position: inside; /* 列表标记放在内容内侧 */
}

.contact-info ul li {
  margin-bottom: 10px; /* 子列表项间距稍小 */
  list-style-type: circle; /* 子列表使用圆形标记 */
}

.contact-info p {
  color: #555; /* 段落文字颜色 */
  line-height: 1.6; /* 行高 */
  margin-top: 5px; /* 段落顶部间距 */
  padding-left: 20px; /* 段落左内边距 */
}

.contact-info h3 {
  color: #2c3e50; /* 标题颜色 */
  border-bottom: 1px solid #eee; /* 标题底部边框 */
  padding-bottom: 5px; /* 标题底部内边距 */
  margin-top: 30px; /* 标题顶部间距 */
}
  display: flex;
  justify-content: space-around;
  max-width: 1200px; /* 增大最大宽度，可按需调整 */
  margin: 0 auto;
}

.contact-form, .contact-info {
  width: 45%;
  text-align: left;
}



.form-group {
  margin-bottom: 15px;
}

label {
  display: block;
  margin-bottom: 5px;
}

input, textarea {
  width: 100%;
  padding: 8px;
  border: 1px solid #ccc;
  border-radius: 4px;
}

button {
  background-color: #007BFF;



/* 鼠标悬停时改变颜色 */
.email:hover {
  color: #0056b3; /* 深一点的蓝色 */
}
  color: white;
  padding: 10px 20px;
  border: none;
  border-radius: 4px;
  cursor: pointer;
}

button:hover {
  background-color: #0056b3;
}
</style>